import React, { useState, useEffect, useRef } from 'react';
import { Box, Button, FormControl, InputLabel, IconButton } from '@mui/material';
import { CloudUpload, Delete } from '@mui/icons-material';

const ImagePicker = ({ label = 'Upload Image', onFileSelect, existingImageUrl = null }) => {
  const [previewUrl, setPreviewUrl] = useState(existingImageUrl);
  const objectUrlRef = useRef(null);

  useEffect(() => {
    setPreviewUrl(existingImageUrl || null);
  }, [existingImageUrl]);

  useEffect(() => {
    return () => { if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current); };
  }, []);

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) return;
    if (file.size > 10 * 1024 * 1024) return;

    if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current);
    const url = URL.createObjectURL(file);
    objectUrlRef.current = url;
    setPreviewUrl(url);
    onFileSelect(file);
  };

  const handleRemove = () => {
    if (objectUrlRef.current) { URL.revokeObjectURL(objectUrlRef.current); objectUrlRef.current = null; }
    setPreviewUrl(null);
    onFileSelect(null);
  };

  return (
    <FormControl fullWidth sx={{ mt: 2 }}>
      <InputLabel shrink sx={{ position: 'relative', transform: 'none', mb: 1, color: 'rgba(0,0,0,0.6)', fontSize: '0.875rem' }}>
        {label}
      </InputLabel>
      <Box sx={{ mt: 4 }}>
        {!previewUrl && (
          <Box>
            <input accept="image/*" style={{ display: 'none' }} id="image-picker-input" type="file" onChange={handleFileSelect} />
            <label htmlFor="image-picker-input">
              <Button variant="outlined" component="span" fullWidth startIcon={<CloudUpload />} sx={{ py: 1.5 }}>
                Select Image
              </Button>
            </label>
          </Box>
        )}
        {previewUrl && (
          <Box sx={{ position: 'relative', maxWidth: 400, borderRadius: 2, overflow: 'hidden', border: '1px solid #e0e0e0' }}>
            <img src={previewUrl} alt="Preview" style={{ width: '100%', height: 'auto', display: 'block' }} />
            <IconButton onClick={handleRemove} sx={{ position: 'absolute', top: 8, right: 8, bgcolor: 'rgba(255,255,255,0.9)' }} size="small">
              <Delete />
            </IconButton>
          </Box>
        )}
      </Box>
    </FormControl>
  );
};

export default ImagePicker;
